module.exports = __webpack_public_path__ + "static/media/banerBN(2).b69fe1a8.jpg";